export enum KnmListByPlanActionsEnum {
  KNM_LIST_BY_PLAN_INIT_PAGE = 'KNM_LIST_BY_PLAN_INIT_PAGE',
  KNM_LIST_BY_PLAN_RESET_PAGE = 'KNM_LIST_BY_PLAN_RESET_PAGE',
  KNM_LIST_BY_PLAN_SET_BASIC_FILTERS = 'KNM_LIST_BY_PLAN_SET_BASIC_FILTERS',
  KNM_LIST_BY_PLAN_GET_DATA = 'KNM_LIST_BY_PLAN_GET_DATA',
  KNM_LIST_BY_PLAN_GET_DATA_NEXT_PAGE = 'KNM_LIST_BY_PLAN_GET_DATA_NEXT_PAGE',
  KNM_LIST_BY_PLAN_SET_DATA = 'KNM_LIST_BY_PLAN_SET_DATA',
  KNM_LIST_BY_PLAN_SET_ORDER = 'KNM_LIST_BY_PLAN_SET_ORDER',
  KNM_LIST_BY_PLAN_SET_SEARCH_VALUE = 'KNM_LIST_BY_PLAN_SET_SEARCH_VALUE',
  KNM_LIST_BY_PLAN_COMMENT_KNM = 'KNM_LIST_BY_PLAN_COMMENT_KNM',
  KNM_LIST_BY_PLAN_DELETE = 'KNM_LIST_BY_PLAN_DELETE',
  KNM_LIST_BY_PLAN_EXCLUDE = 'KNM_LIST_BY_PLAN_EXCLUDE',
  KNM_LIST_BY_PLAN_APPROVE = 'KNM_LIST_BY_PLAN_APPROVE',
  KNM_LIST_BY_PLAN_FILTER_SET_LOADING = 'KNM_LIST_BY_PLAN_FILTER_SET_LOADING',
  KNM_LIST_BY_PLAN_FILTER_SET_SWITCHER = 'KNM_LIST_BY_PLAN_FILTER_SET_SWITCHER',
  KNM_LIST_BY_PLAN_FILTER_SET_CURRENT = 'KNM_LIST_BY_PLAN_FILTER_SET_CURRENT',
  KNM_LIST_BY_PLAN_FILTER_GET_META = 'KNM_LIST_BY_PLAN_FILTER_GET_META',
  KNM_LIST_BY_PLAN_FILTER_SET_META = 'KNM_LIST_BY_PLAN_FILTER_SET_META',
  KNM_LIST_BY_PLAN_FILTER_GET_DATA = 'KNM_LIST_BY_PLAN_FILTER_GET_DATA',
  KNM_LIST_BY_PLAN_FILTER_SET_DATA = 'KNM_LIST_BY_PLAN_FILTER_SET_DATA',
  KNM_LIST_BY_PLAN_FILTER_CREATE = 'KNM_LIST_BY_PLAN_FILTER_CREATE',
  KNM_LIST_BY_PLAN_FILTER_UPDATE = 'KNM_LIST_BY_PLAN_FILTER_UPDATE',
  KNM_LIST_BY_PLAN_FILTER_REMOVE = 'KNM_LIST_BY_PLAN_FILTER_REMOVE',
  KNM_LIST_BY_PLAN_SET_SUPERVISION_TYPE_DICT_VERSION_ID = 'KNM_LIST_BY_PLAN_SET_SUPERVISION_TYPE_DICT_VERSION_ID',
  KNM_LIST_BY_PLAN_APPROVE_REMARKS = 'KNM_LIST_BY_PLAN_APPROVE_REMARKS',
}
